import { VideoFormState } from '../types/heygen';
import { AVATAR_MATRIX } from '../constants/avatar-matrix';
import { AvatarProjectFormData } from '../../../types/avatar-video';

/**
 * Convierte la response del endpoint `/form-data` en un `VideoFormState` listo
 * para poblar el form del Studio.
 *
 * Reemplaza al viejo `parsePayload(HeyGenPayload)` — que dependía de
 * `project.payload.video_inputs`. Ahora leemos directo de los scene records
 * expuestos por el endpoint.
 *
 * Busca el `talking_photo_id` en `AVATAR_MATRIX` para reconstruir
 * vestuario / ambiente / plano en la UI. Si no matchea (avatar legacy),
 * deja los campos vacíos.
 */
export const parseFormData = (data: AvatarProjectFormData): VideoFormState => {
  return {
    title: data.title,
    voiceId: '',
    // talkingStyle no es configurable desde la UI por ahora; siempre se usa el default.
    talkingStyle: 'expressive',
    promptKey: 'professional',
    scenes: data.scenes.map(scene => {
      if (scene.onlyVoice) {
        return {
          sceneId: scene.sceneId,
          vestuario: '',
          ambiente: '',
          plano: '',
          script: scene.script,
          onlyVoice: true
        };
      }
      const photoId = scene.character.talking_photo_id;
      const entry = AVATAR_MATRIX.find(a => a.photoId === photoId);
      return {
        sceneId: scene.sceneId,
        vestuario: entry?.vestuario ?? '',
        ambiente: entry?.ambiente ?? '',
        plano: entry?.plano ?? 'medio',
        script: scene.script,
        onlyVoice: false
      };
    })
  };
};
